
import { MeshEffect } from "../MeshEffect";
import type {
  EffectArchetype,
  MeshEffectKind,
  WindEffectParams,
} from "../types";
import type { MeshEffectDriver } from "../MeshEffectDriver";
import { VegetationWindDriver } from "../drivers/VegetationWindDriver";

/**
 * Wind Mesh Effect — applies directional wind sway to vegetation objects.
 *
 * Archetype → Driver mapping:
 *   vegetation → VegetationWindDriver (GPU vertex displacement via onBeforeCompile)
 *
 * Future archetypes:
 *   creature  → BoneWindDriver (not yet implemented)
 *   structure → TransformWindDriver (not yet implemented)
 */
export class WindMeshEffect extends MeshEffect<WindEffectParams> {
  readonly kind: MeshEffectKind = "wind";
  readonly supportedArchetypes: EffectArchetype[] = ["vegetation"];

  private vegetationDriver = new VegetationWindDriver();

  resolveDriver(
    archetype: EffectArchetype,
  ): MeshEffectDriver<WindEffectParams> | null {
    if (this.vegetationDriver.canApply(archetype)) {
      return this.vegetationDriver;
    }
    return null;
  }

  getDefaultParams(_archetype: EffectArchetype): WindEffectParams {
    return {
      stiffness: 0.5,
      amplitude: 0.2,
    };
  }
}
